export default "__VITE_ASSET__CF7l9s8z__"